/*
 * @Description: 
 * @Author: 李方强
 * @Date: 2019-07-25 16:12:31
 * @LastEditTime: 2021-07-30 14:58:44
 * @LastEditors: lkz
 */
/*
 本文件用于定义与API接口服务的代码
 只允许导出接口方法，不允许导出其它非接口方法的功能
 */
import * as httpAgent from 'utils/http'


/**
 * 查询正在排队用户，
 * 每5秒定时请求一次，
 * 点击其他侧栏取消定时
 * 
 * * */
export function QueueUp(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/admin/xinyun/allocation/queueUp', params, options)
}

/** *
 * 接待用户
 * empId  客服登录时获取的id
 * consumerId  被接待的id
 * 
 * * */
export function getReception(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/admin/xinyun/allocation/reception', params, options)
}


/** *
 * 历史记录
 * 
 * * */
export function getList(params, options) {
  return httpAgent.GET('/yunjiIm/service/message/list', params, options)
}

/**
 *点击顶部上线开始连接websocket 
 * 
 * */

export function getTopstatus(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/admin/xinyun/allocation/customerServiceSetStatus', params, options)
}


// /** *
//  * 关闭会话
//  * 
//  * * */
// export function closeDialogue(params, options) {
//   return httpAgent.GET('/yunjixinyunadmin/admin/xinyun/allocation/closeDialogue', params, options)
// }


/** *
 * 获取技能组， 针对转交
 * ** */

export function getGroupAll(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/admin/xinyun/skillGroup/findByGroupTitle', params, options)
}

/** *
 * 获取客服， 针对转交
 * ** */

export function getAllcurrentCase(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/admin/xinyun/customerService/findCustomerServiceCurrentCase', params, options)
}


/** *
 * 转交技能组
 * ** */
export function makeOverSkillGroup(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/admin/xinyun/allocation/makeOverSkillGroup', params, options)
}

/** *
 * 转交客服
 * ** */
export function makeOverService(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/admin/xinyun/allocation/makeOverService', params, options)
}

/** *
 * 客服上线后自动分配用户
 * ** */

export function allocaTionCustomer(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/admin/xinyun/allocation/allocationCustomer', params, options)
}


/** *
 * 上传图片
 * ** */

export function upLoad(params, options) {
  return httpAgent.POST('/yunjixinyunadmin/admin/xinyun/upload/uploadPic_json.json', params, options)
}

/** *
 * 获取右侧用户信息
 * * */

export function getConsumerInfo(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/admin/xinyun/customerService/getConsumerInfo', params, options)
}

/** *
 * 判断是否有聊天记录
 * * */

export function hasMessage(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/admin/xinyun/customerService/hasMessage', params, options)
}

/**
 * 获取tree
 *
 * @export
 * @returns
 */
export function workList(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/admin/xinyun/fastResponse/list', params, options)
}


/** *
 * 获取历史列表
 * 
 * ** */


export function findHistoryByEmpId(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/admin/xinyun/customerService/findHistoryByEmpId', params, options)
}

/** *
 * 拉取对话历史记录
 * 
 * *** */

export function messageList(params, options) {
  return httpAgent.GET('yunjixinyunadmin/admin/xinyun/customerService/messageList', params, options)
}

/** *
 * 右侧获取补偿列表
 * ** */
export function searchCompensateList(params, options) {
  return httpAgent.GET('yunjixinyunadmin/xinyun/refund/searchCompensateList.json', params, options)
}

/** *
 * 右侧获取售后列表
 * ** */
export function returnMoneyDetailList(params, options) {
  return httpAgent.GET('yunjixinyunadmin/xinyun/refund/returnMoneyDetailList', params, options)
}


/**
 * 获取tree
 *
 * @export
 * @returns
 */
export function fastResponseList(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/admin/xinyun/serviceIssue/listChild', params, options)
}

/** *
 * 获取所有服务小记的对象
 * * */
export function getServiceSubtotalTarget(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/admin/xinyun/serviceSubtotal/getServiceSubtotalTarget', params, options)
}


/** *
 * 获取所有服务小记诉求
 * * */
export function getServiceSubtotalAppeal(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/admin/xinyun/serviceSubtotal/getServiceSubtotalAppeal', params, options)
}


/** *
 * 新建服务小记
 * * */

export function Savexj(params, options) {
  return httpAgent.POST('/yunjixinyunadmin/admin/xinyun/serviceSubtotal/save', params, options)
}


/** *
 * 所有快递公司
 * * */

export function searchDeliverCompanys(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/xinyun/refund/searchDeliverCompanys', params, options)
}

/** *
 * 查询工单
 * * */

export function queryWorkOrders(params, options) {
  return httpAgent.POST('/kpi/yunjixinyun/admin/xinyun/workorder/queryWorkOrders', params, options)
}

/**
 * 点击顶部状态判断是否需要OA审批
 * @export
 * @param {*} params
 * @param {*} data
 * @returns
 */
export function verifyOaCheck(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/admin/xinyun/allocation/verifyOaCheck', params, options)
}

/**
 * 新客服状态
 * @export
 * @param {*} params
 * @param {*} data
 * @returns
 */
export function newCustomerStatus(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/admin/xinyun/allocation/newCustomerStatus', params, options)
}

/** *
 * 通过工号查询前十条未读取消息
 * * */

export function findByNoReadBeforeTenMessageList(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/admin/xinyun/messageBox/findByNoReadBeforeTenMessageList', params, options)
}

/** *
 * 设置未读消息成已读
 * * */

export function batchUpdateToRead(params, options = { type: 'formData' }) {
  return httpAgent.POST('/yunjixinyunadmin/admin/xinyun/messageBox/batchUpdateToRead', params, options)
}

/** *
 * 获取消息盒子跳转地址
 * * */

export function findByJumpUrl(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/admin/xinyun/messageBox/findByJumpUrl.json', params, options)
}

// 获取客服个人指标
export function getEmpIndex(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/admin/xinyun/customerService/getEmpIndex', params, options)
}
